import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { Modal,Input,Form } from 'antd';
import './messageRequest.css';
import PropTypes from 'prop-types';

import asReviewWpaFormConfim from '../../public/img/std/asReviewWpaFormConfim.png'
import cancelImg from '../../public/img/newMain/cancel.png';

/**
 * 消息提示组件
 * props传参如下
 * 消息提示类型,样式 ['error','success','warning','info']
 *                              error:错误提示框，红色样式
 *                              success:成功提示框，绿色样式
 *                              warning:警告提示框，黄色样式
 *                              info:普通提示框，蓝色样式
 */
let MessageRequest = (props, ref) => {

    const [content, setContent] = useState("");
    const [isShow, setIsShow] = useState(false);
    const [form] = Form.useForm();
    useImperativeHandle(ref, () => {
        return {
            setContent,
            setIsShow,
        }
    });

    /**
     * 标题默认值处理
     */
    useEffect(() => {
    }, []);

    const save = ()=>{
        form.submit();
        if(form.getFieldValue("eventRemark")=="" || form.getFieldValue("eventRemark")==undefined){
            return;
        }
        const eventRemark =  form.getFieldValue("eventRemark")
        form.resetFields()
        props.done("save",eventRemark);
    }

    const save2 = ()=>{
        form.resetFields()
        props.done("cancel");
    }

    return (
        <Modal
            open={isShow}
            onCancel={null}
            closeIcon={null}
            footer={null}
            className='messageRequest'
            width={735}
            centered
            closable={false}
        >
            <div className='contentBox'>
                {content}
            </div>
            <Form form={form}>
                <Form.Item
                    name="eventRemark"
                    rules={[
                        { required: true, message: 'Message is required.' },
                    ]}
                >
                    <Input.TextArea className="textArea"  maxLength={250} rows={3}/>
                </Form.Item>
            </Form>
            <div className='butArea'>
                <div className='saveButton' onClick={save}><img src={asReviewWpaFormConfim} />Submit</div>
                <div className='cancelButton' onClick={save2}><img src={cancelImg} />Cancel</div>
            </div>
            
        </Modal>
    )

}

MessageRequest = forwardRef(MessageRequest);

MessageRequest.propTypes = {
    done: PropTypes.func.isRequired,
};

export default MessageRequest;